export var REQUEST_BET_TYPES = 'REQUEST_BET_TYPES';
export var SUCCESS_REQUEST_BET_TYPES = 'SUCCESS_REQUEST_BET_TYPES';
export var FAILURE_REQUEST_BET_TYPES = 'FAILURE_REQUEST_BET_TYPES';
export var SELECT_SYSTEM_VARIANT = 'SELECT_SYSTEM_VARIANT';



// WEBPACK FOOTER //
// ./src/actions/coupon/betTypes.js